<template>
  <div class="xiaoman-page">
    <crumb-tit>
      <span slot="breadTit">小满集成</span>
      <span slot="secondTit">小满集成</span>
    </crumb-tit>

    <a-tabs
      :active-key="activeKey"
      tab-position="top"
      :animated="false"
      @change="tabCallback"
    >
      <a-tab-pane
        key="1"
        tab="基础配置"
      />
      <a-tab-pane
        key="2"
        tab="对应字段"
      />
    </a-tabs>
    <router-view />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import CrumbTit from '@/components/pc/config/CrumbTit'

export default {
  components: {
    CrumbTit
  },

  data () {
    return {
      activeKey: '1'
    }
  },

  computed: {
    documentTitle () {
      let { projectname = '', comname = '' } = this.$store.state.baseinfo || {}
      projectname && (projectname = ' - ' + projectname)
      comname && (comname = ' - ' + comname)
      document.title = '小满集成' + projectname + comname
      return '小满集成' + projectname + comname
    }
  },

  watch: {
    $route: {
      handler (to) {
        let key = '1'
        switch (to.name) {
          case 'XiaomanBaseConfig':
            key = '1'
            break
          case 'XiaomanSetFields':
            key = '2'
            break
          default:
            key = '1'
            break
        }
        this.activeKey = key
        this.fetchXiaomanBaseInfo({
          showLoading: false
        })
      },
      immediate: true
    },
    documentTitle: {
      handler (val) {
        document.title = val
      },
      immediate: true
    }
  },

  async mounted () {
    await this.fetchXiaomanBaseInfo({
      showLoading: true
    })
  },

  methods: {
    ...mapActions('config/xiaoman', ['fetchXiaomanBaseInfo']),

    tabCallback (key) {
      let routeName
      if (key === '1') {
        routeName = 'XiaomanBaseConfig'
      } else if (key === '2') {
        routeName = 'XiaomanSetFields'
      }
      this.$router.push({
        name: routeName
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.xiaoman-page::v-deep {
  .ant-tabs {
    margin-top: 24px;
  }
  .ant-tabs-nav-wrap {
    border-top: solid 1px #ebebeb;
  }
  .ant-tabs-bar {
    border-bottom: 0 none;
  }
  .ant-tabs-nav {
    .ant-tabs-tab {
      margin-right: 16px;
      padding: 8px 2px;
      font-size: 18px;
      font-weight: bold;
      line-height: 32px;
    }
  }
}
</style>
